<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 12C13.944 12 15.52 10.433 15.52 8.5C15.52 6.567 13.944 5 12 5C10.056 5 8.48 6.567 8.48 8.5C8.48 10.433 10.056 12 12 12ZM12 12C8.11192 12 4.96 15.134 4.96 19M12 12C15.8881 12 19.04 15.134 19.04 19M17.72 6.3125C19.178 6.3125 20.36 7.48775 20.36 8.9375C20.36 10.3872 19.178 11.5625 17.72 11.5625C20.6361 11.5625 23 13.913 23 16.8125M6.28 6.3125C4.82197 6.3125 3.64 7.48775 3.64 8.9375C3.64 10.3872 4.82197 11.5625 6.28 11.5625C3.36394 11.5625 1 13.913 1 16.8125"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
